// src/components/Auth/DecryptionErrorModal.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './DecryptionErrorModal.css';

/**
 * Modal component for displaying wallet decryption errors
 * Allows users to retry with a new password
 */
const DecryptionErrorModal = ({ isOpen, message, onRetry, onClose, isLoading }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div className="decryption-error-overlay">
      <div className="decryption-error-modal">
        <div className="decryption-error-header">
          <h2>{t('auth.decryptionError.title')}</h2>
          <button className="decryption-error-close" onClick={onClose}>×</button>
        </div>
        
        <div className="decryption-error-content">
          <div className="decryption-error-icon">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#ff4d4d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          
          <p className="decryption-error-message">
            {message || t('auth.decryptionError.message')}
          </p>
          
          <p className="decryption-error-tip">
            {t('auth.decryptionError.tip')}
          </p>
        </div>
        
        <div className="decryption-error-actions">
          <button 
            className="secondary-button" 
            onClick={onClose}
            disabled={isLoading}
          >
            {t('auth.decryptionError.cancel')}
          </button>
          <button 
            className="primary-button" 
            onClick={onRetry}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span>
                {t('auth.decryptionError.retrying')}
              </>
            ) : (
              t('auth.decryptionError.retry')
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DecryptionErrorModal;